var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "ul",
            { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
            [
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c("router-link", { attrs: { to: { name: "home" } } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _c("i", { staticClass: "m-nav__link-icon la la-home" })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t  \t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(_vm._f("translate")("surveillance"))
                      ) +
                      "\n\t\t  \t  \t\t"
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "m-portlet" }, [
        _c("div", { staticClass: "m-portlet__body align-center" }, [
          _c("i", { staticClass: "flaticon-placeholder icon-principal" }),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            {},
            [
              _c("s-datatable", {
                attrs: { show_spinner: false, config: _vm.datatable }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8af3c52", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8af3c52","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/surveillance/Surveillance.vue
// module id = 854
// module chunks = 0 1 79